
import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Ref
} from "vue-property-decorator";

import api from "@/api";

import {
  CreateOrEditProjectDto,
  OrganizationUnitDto,
  AuditFlowDto, ProjectPaymentsAndReceiptsesCreateOrEditDto, ProjectDto, ProjectPaymentsAndReceiptsesDto
} from "@/api/appService";

import AbSelect from "@/components/AbSelect/index.vue";
import { ElForm } from "element-ui/types/form";

@Component({
  components: { AbSelect }
})
export default class EditProject extends Vue {
  @Ref() readonly dataForm!: ElForm;



  @Prop()
  dataId!:number;

  @Prop({default:0})
  projectId!:number;


  // fields

  show = false;

  private form:ProjectPaymentsAndReceiptsesCreateOrEditDto = {};

  defaultData: ProjectPaymentsAndReceiptsesCreateOrEditDto = {
    category: undefined,
    paymentCycleType: undefined,
    projectId: undefined,
    occurrenceDate: undefined,
    amount: undefined,
    id: 0,
  };


  // private fields
  private projectList:ProjectDto[] = [];
  private categories:any = [{
    label:'收款',value:'Proceeds'
  },{
    label:'拨款',value:'AllocateFunds'
  }];
  private cycleTypes:any = [{
    label:'首款',value:'First'
  },{
    label:'中期款',value:'Interim'
  },{
    label:'尾款',value:'Finally'
  }];



  get dialogTitle() {
    return this!.dataId ? "编辑" : "新建";
  }

  async created() {
    await this.loadProjectList();
  }

  @Watch("show")
  async onShowChange(value: boolean) {

    if (!value) {
      this.form = {...this.defaultData};
    } else {
      await api.ProjectPaymentsAndReceiptses.getForEdit({
        id: this.dataId
      }).then(res => {
        this.form = res.data!;
        if(!this.form.projectId){
          this.form.projectId = this.projectId
        }
      });


    }
    this.$nextTick(() => {
      this.dataForm.clearValidate();
    });
  }

  async loadProjectList(){
    if(!this.projectList || !this.projectList.length){
      await api.project.getAll({maxResultCount:65535}).then(res=>{
        this.projectList = res.items!;
      })
    }
  }






  async save() {
    console.log(this.form);
    this.dataForm.validate(async (valid: boolean) => {
      if (valid) {
        if (this.form!.id) {
          await api.ProjectPaymentsAndReceiptses.update({body:this.form});
        } else {
          await api.ProjectPaymentsAndReceiptses.create({
            body: this.form
          });
        }
        this.show = false;
        this.$message.success("更新成功");
      }
    });
  }

  cancel() {
    this.show = false;
  }

  roleRule = {
    projectId: [
      {
        required: true,
        message: "请选择项目",
        trigger: "blur"
      }
    ],
    occurrenceDate:[
      {
        required: true,
        message: "必须",
        trigger: "blur"
      }
    ],
    amount: [
      {
        required: true,
        message: "金额是必须的",
        trigger: "change"
      }
    ],
    category: [
      {
        required: true,
        message: "类别是必须的",
        trigger: "blur"
      }
    ],
    cycleType: [
      {
        required: true,
        message: "阶段为必选项",
        trigger: "blur"
      }
    ],
  };
}
